import { render, staticRenderFns } from "./StartRepair.vue?vue&type=template&id=d9a4f10a"
import script from "./StartRepair.vue?vue&type=script&lang=js"
export * from "./StartRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports